"use strict";

define('rs/models/meeting.person',['rs/models/abstract', 'rs/models/person'], function (RSAbstractModel, Person) {
  var MeetingPerson = RSAbstractModel.extend({
    properties: ['person', 'meetingId', 'present'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      if (this.getPerson()) {
        this.setPerson(Person.model(this.getPerson()));
      }
    },
    sync: function sync() {
      return this.constructor.requestUpdate(this.toJSON());
    },
    toJSON: function toJSON() {
      var person = this.getPerson();
      return {
        person: person ? {
          id: person.id
        } : null,
        meetingId: this.getMeetingId(),
        personId: person ? person.id : null,
        present: !!this.getPresent()
      };
    }
  }, {
    rootURI: '/rs/api/meetingPerson/',
    routes: {
      'PUT :meetingId/:personId': 'requestUpdate'
    }
  });
  return MeetingPerson;
});

